export type PositionedPlace<T> = { place: T; x: number; y: number };

// Sceglie quali segnaposto mostrare senza sovrapposizioni. L'ordine dei candidati decide chi vince:
// va costruito in modo stabile (stesso ordine a ogni spostamento) per non far apparire e sparire luoghi.
export function spacedPlaces<T>(points: PositionedPlace<T>[], limit = 400): T[] {
  const kept: PositionedPlace<T>[] = [];
  for (const point of points) {
    if (kept.every(other => Math.abs(point.x - other.x) >= 118 || Math.abs(point.y - other.y) >= 96)) kept.push(point);
    if (kept.length >= limit) break;
  }
  return kept.map(point => point.place);
}

// Priorità fissa di un luogo, uguale a ogni inquadratura (non dipende da cosa è visibile).
export function stableRank(id: string): number {
  let hash = 2166136261;
  for (let index = 0; index < id.length; index++) hash = Math.imul(hash ^ id.charCodeAt(index), 16777619);
  return hash >>> 0;
}
